import React from "react"

export default function Bell() {
  return (
    <symbol id="svg-bell" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        d="M26.8 22.6H5.2c-.5 0-1-.4-1-1s.4-1 1-1c0 0 1.8-.5 2.2-7.3C7.8 3.8 15.9 4 16 4c0 0 8.2-.1 8.7 9.3.3 6.9 2.2 7.3 2.2 7.3.5 0 1 .5 1 1-.1.5-.5 1-1.1 1zm-19-2h16.4c-.7-1.3-1.3-3.6-1.5-7.2C22.3 5.9 16.3 6 16 6c-.3 0-6.4 0-6.7 7.4-.2 3.6-.8 5.8-1.5 7.2zm19.1 1zm-21.7 0c-.1 0 0 0 0 0zm10.9 6.3H16c-1.7-.1-2.8-1.5-2.9-1.6-.3-.4-.2-1.1.2-1.4s1.1-.2 1.4.2c.2.2.8.8 1.4.8.5 0 1-.3 1.5-.9.4-.4 1-.5 1.4-.1s.5 1 .1 1.4c-.9 1.1-1.9 1.6-3 1.6z"
      />
    </symbol>
  )
}
